/**
 * Check if the given KitchenOrder already contains an equivalent KitchenItem. Returns that item if it does.
 * Equivalent means its the same itemID and the same answers to field data (anything the kitchen needs to
 * be unique).
 *
 * The kitchen is not concerned with offers etc. so lines split up due to offers get merged back together
 * for the kitchen.
 *
 * @param {KitchenOrder} kitchenOrder
 * @param {KitchenOrderItem} findItem
 *
 * @return {KitchenOrderItem|undefined}
 */
const findKitchenItemInOrder = (kitchenOrder, findItem) => {
    return kitchenOrder.items.find(
        (item) => item.hash && item.hash === findItem.hash && item.isFulfilled === false
    );
};

module.exports = {
    findKitchenItemInOrder,
};
